const dataFeedback = [
  { investorType: 'Venture Capital', date: '02/07/20', count: 1 },

  { investorType: 'Venture Capital', date: '06/07/20', count: 1 },
  { investorType: 'Mutual Fund', date: '06/07/20', count: 2 },

  { investorType: 'Venture Capital', date: '09/07/20', count: 1 },

  { investorType: 'Venture Capital', date: '13/07/20', count: 1 },
  { investorType: 'PE', date: '13/07/20', count: 1 },
  { investorType: 'Mutual Fund', date: '13/07/20', count: 1 },
  { investorType: 'Holding Company', date: '13/07/20', count: 1 },

  { investorType: 'Venture Capital', date: '14/07/20', count: 2 },
  { investorType: 'PE', date: '14/07/20', count: 1 },

  { investorType: 'PE', date: '15/07/20', count: 1 },
  { investorType: 'SWF', date: '15/07/20', count: 1 },

  { investorType: 'Mutual Fund', date: '17/07/20', count: 2 },

  { investorType: 'Venture Capital', date: '20/07/20', count: 1 },
  { investorType: 'PE', date: '20/07/20', count: 1 },

  { investorType: 'Mutual Fund', date: '21/07/20', count: 1 },

  { investorType: 'SWF', date: '21/07/20', count: 1 },

  { investorType: 'Hedge Fund', date: '22/07/20', count: 1 },

  { investorType: 'Venture Capital', date: '23/07/20', count: 2 },
  { investorType: 'Mutual Fund', date: '23/07/20', count: 2 },

  { investorType: 'Corporate', date: '28/07/20', count: 1 },
  { investorType: 'Holding Company', date: '28/07/20', count: 1 },

  { investorType: 'Corporate', date: '29/07/20', count: 1 },

  { investorType: 'Pension Fund', date: '29/07/20', count: 1 }
];

/* const dataFeedback = [
  { investorType: 'VC', date: '01/01/20', count : 5 },
  { investorType: 'Private Equity', date: '01/01/20', count : 2 },
  { investorType: 'Corporate Venture', date: '01/01/20', count : 0 },
  { investorType: 'Family Office/Holding', date: '01/01/20', count : 4 },
  { investorType: 'Pension Fund', date: '01/01/20', count : 4 },
  { investorType: 'Mutual Fund', date: '01/01/20', count : 0 },
  { investorType: 'Hedge Fund', date: '01/01/20', count : 0 },
  { investorType: 'Others', date: '01/01/20', count : 4 },
  
  { investorType: 'VC', date: '02/01/20', count : 0 },
  { investorType: 'Private Equity', date: '02/01/20', count : 2 },
  { investorType: 'Corporate Venture', date: '02/01/20', count : 10 },
  { investorType: 'Family Office/Holding', date: '02/01/20', count : 4 },
  { investorType: 'Pension Fund', date: '02/01/20', count : 0 },
  { investorType: 'Mutual Fund', date: '02/01/20', count : 0 },
  { investorType: 'Hedge Fund', date: '02/01/20', count : 0 },
  { investorType: 'Others', date: '02/01/20', count : 4 },
  
  { investorType: 'VC', date: '03/01/20', count : 5 },
  { investorType: 'Private Equity', date: '03/01/20', count : 2 },
  { investorType: 'Corporate Venture', date: '03/01/20', count : 10 },
  { investorType: 'Family Office/Holding', date: '03/01/20', count : 4 },
  { investorType: 'Pension Fund', date: '03/01/20', count : 0 },
  { investorType: 'Mutual Fund', date: '03/01/20', count : 0 },
  { investorType: 'Hedge Fund', date: '03/01/20', count : 0 },
  { investorType: 'Others', date: '03/01/20', count : 0 },
  
  { investorType: 'VC', date: '04/01/20', count : 5 },
  { investorType: 'Private Equity', date: '04/01/20', count : 0 },
  { investorType: 'Corporate Venture', date: '04/01/20', count : 0 },
  { investorType: 'Family Office/Holding', date: '04/01/20', count : 0 },
  { investorType: 'Pension Fund', date: '04/01/20', count : 0 },
  { investorType: 'Mutual Fund', date: '04/01/20', count : 4 },
  { investorType: 'Hedge Fund', date: '04/01/20', count : 4 },
  { investorType: 'Others', date: '04/01/20', count : 4 },
  
  { investorType: 'VC', date: '05/01/20', count : 0 },
  { investorType: 'Private Equity', date: '05/01/20', count : 2 },
  { investorType: 'Corporate Venture', date: '05/01/20', count : 10 },
  { investorType: 'Family Office/Holding', date: '05/01/20', count : 4 },
  { investorType: 'Pension Fund', date: '05/01/20', count : 0 },
  { investorType: 'Mutual Fund', date: '05/01/20', count : 4 },
  { investorType: 'Hedge Fund', date: '05/01/20', count : 0 },
  { investorType: 'Others', date: '05/01/20', count : 0 },
  
  { investorType: 'VC', date: '06/01/20', count : 5 },
  { investorType: 'Private Equity', date: '06/01/20', count : 3 },
  { investorType: 'Corporate Venture', date: '06/01/20', count : 0 },
  { investorType: 'Family Office/Holding', date: '06/01/20', count : 0 },
  { investorType: 'Pension Fund', date: '06/01/20', count : 4 },
  { investorType: 'Mutual Fund', date: '06/01/20', count : 0 },
  { investorType: 'Hedge Fund', date: '06/01/20', count : 0 },
  { investorType: 'Others', date: '06/01/20', count : 0 },
  
  { investorType: 'VC', date: '07/01/20', count : 5 },
  { investorType: 'Private Equity', date: '07/01/20', count : 0 },
  { investorType: 'Corporate Venture', date: '07/01/20', count : 3 },
  { investorType: 'Family Office/Holding', date: '07/01/20', count : 0 },
  { investorType: 'Pension Fund', date: '07/01/20', count : 4 },
  { investorType: 'Mutual Fund', date: '07/01/20', count : 0 },
  { investorType: 'Hedge Fund', date: '07/01/20', count : 2 },
  { investorType: 'Others', date: '07/01/20', count : 14 },
]; */

export default dataFeedback;
